import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { _BudgetObligationFactory } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { Modal } from "../../../../../theme/Component/Modal";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";

interface conf {
    label?: string;
}

interface Props {
    idAccount: number;
    paymentDate: any;
    onChange: Function;
    configProps?: conf;
    idDocument?: number;
}

export const OBsEditor = ({ idAccount, paymentDate, onChange, configProps, idDocument }: Props) => {

    const { instance, setLista, lista, bean, setBean } = useDataBean(_BudgetObligationFactory)
    const [valor, setValor] = useState<string>("")
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        if (idAccount) {
            getOBS()
        }
    }, [idAccount, paymentDate])

    const getOBS = () => {
        instance.getObligationBudgetDocumentsByAccount(idAccount, paymentDate).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    useEffect(() => {
        if (idDocument && lista.length > 0) {
            const foundItem = lista.find((item: any) => item.DataBeanProperties.IDDocument === idDocument);
            if (foundItem) {
                setBean(foundItem.DataBeanProperties);
                setValor(`${foundItem.DataBeanProperties.Mnemonic} - ${foundItem.DataBeanProperties.Consecutive} - $${foundItem.DataBeanProperties.OBValue}`);
                if (onChange) {
                    onChange(foundItem.DataBeanProperties);
                }
            }
        }
    }, [idDocument, lista]);

    const getItem = () => {
        if (bean.IDDocument) {
            setModal({ ...modal, "view": false });
            setValor(`${bean.Mnemonic} - ${bean.Consecutive} - $${bean.OBValue}`);
            if (onChange) {
                onChange(bean);
            }
        } else {
            toast.error("OB no valida")
        }
    }

    const head = [
        { title: 'ID', property: 'IDDocument', visible: true, mask: MASK_NUMBER },
        { title: 'Mnemonico', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Fecha de Documento', property: 'DocumentDate', visible: true },
        { title: 'Valor', property: 'OBValue', visible: true, mask: MASK_MONEY },
    ]

    return (
        <>

            <label>{configProps?.label ?? "Obligacion Presupuestal"}</label>
            <div className="form-control text-wrap" style={{ minHeight: '35px' }} onClick={() => setModal({ ...modal, "view": true, "name": "Obligaciones Presupuestales del tercero" })}>
                {valor ? (
                    valor
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={getItem}>
                <div className="row">
                    <div className="col-md-12">
                        <BasicTable body={lista} head={head} rowSet={setBean} />
                    </div>
                </div>
            </Modal>
        </>
    )
}